import { RouteComponentProps, useLocation } from "@reach/router";
import React, { useEffect } from "react";
import useTranslate from "../../../../hooks/use-translate";
import { analyticsTrackEvent } from "../../../../services/analytics";
import { getUserMembershipSubscription } from "../../../../services/membership";
import { getAllPaymentMethods } from "../../../../services/payment";
import Authenticate from "../../../authentication/containers/Authenticate";
import ActivationLayout from "../../components/Layout";
import { getFullWindowMinHeight } from "../../components/Layout/utils";
import { navigateActivation } from "../../utils/url";

type Props = RouteComponentProps<{ podKeyOrSerialNumber: string }>;

export default function ActivationUserRegister({
  podKeyOrSerialNumber
}: Props) {
  const t = useTranslate();

  const { pathname } = useLocation();
  const isSignIn = pathname.includes("/sign-in");

  const handleAuthentication = async () => {
    const { membershipSubscription } = await getUserMembershipSubscription();
    if (membershipSubscription) {
      navigateActivation(`${podKeyOrSerialNumber}/activation-light`);
    } else {
      const paymentMethods = await getAllPaymentMethods();
      if (paymentMethods?.length > 0) {
        navigateActivation(`${podKeyOrSerialNumber}/payment`);
      } else {
        navigateActivation(`${podKeyOrSerialNumber}/payment-info`);
      }
    }
  };

  return (
    <ActivationLayout fullHeight>
      <Authenticate
        type={isSignIn ? "sign-in" : "register"}
        labels={{
          signIn: {
            title: "You're almost there. Sign in to unlock your pod."
          },
          register: {
            title: "You're almost there. Create an account to unlock your pod."
          }
        }}
        onAuthentication={handleAuthentication}
        fullHeight
        minHeight={{
          xs: getFullWindowMinHeight({ offset: 48 }),
          sm: "0px"
        }}
      />
    </ActivationLayout>
  );
}
